let wrapper1 = document.getElementById("ImageWithText--template--20741262147857__ec330763-9000-4fe2-95fa-24454f3c114c");
wrapper1.style.cursor = "pointer";

wrapper1.addEventListener("click", function() {
  // Define the function that will be called Dennis james element
  const openFirstWindow = new Promise((resolve) => {
    const firstWindow = window.open('https://www.amazon.in/s?i=merchant-items&me=A3MI4FKI74EQ8R&rh=p_4%3ADENNIS+JAMES&dc&marketplaceID=A21TJRUUN4KGV&qid=1694502462&ref=sr_nr_p_4_6&ds=v1%3APC2eM1S5W%2Fk3qovlt6jYBDXwJHJHn1SuH0489zJUgxw',
      '_blank');
      
    // Check if the first window opened successfully
    if (firstWindow) {
      // Resolve the promise after a delay (adjust this as needed)
      setTimeout(resolve, 2000); // 2 second delay
    } else {
          }
  });

  // Wait for the first window to open and then open the second one
  openFirstWindow.then(() => {
    // Define the function that will be called Pole element
    window.open('https://www.amazon.in/s?i=merchant-items&me=A3MI4FKI74EQ8R&rh=p_4%3APOLE+NUTRITION+PRO6&dc&marketplaceID=A21TJRUUN4KGV&qid=1694502462&ref=sr_nr_p_4_2&ds=v1%3A%2B8uH6TCeBBrqViYZXvblDspFgeYVLnQt%2BM4sQN1nyWQ',
      '_blank');
  }).catch((error) => {
  });
});
